import React from "react";
import { Container, Tab, Tabs } from "react-bootstrap";

import PageHeader from "../../components/PageHeader";
import ChangePassword from "../../components/tabs/my-profile/ChangePassword";
import EditProfile from "../../components/tabs/my-profile/EditProfile";

const MyProfile: React.FC = () => {
  return (
    <Container className="w-800">
      <PageHeader title="My Profile" titleClass="text-capitalize" />
      <div className="tabs-wrapper">
        <Tabs defaultActiveKey="profile" id="eds-admin-settings">
          {/* Profile tab  */}
          <Tab eventKey="profile" title="Profile">
            <EditProfile />
          </Tab>

          {/* Change Password tab  */}
          <Tab eventKey="change-password" title="Change Password">
            <ChangePassword />
          </Tab>
        </Tabs>
      </div>
    </Container>
  );
};

export default MyProfile;
